import { Row, Col, Checkbox, Form, Radio, notification } from 'antd'
import { showDefaultQueries } from './shared'
import { QueryEditor } from 'Components'
import { useEffect, useState } from 'react'

queryLanguages = ['QueryBuilder', 'Sparql']

Graph = ({ extra, viewNode, setFieldsValue }) ->
  [separateTreeQuery, setSeparateTreeQuery] = useState(false)
  [queryType, setQueryType] = useState(viewNode?.get('queryType') or 'QueryBuilder')

  useEffect(->
    if viewNode?.get('treeQuery')?
      setSeparateTreeQuery(true)
    undefined
  , [viewNode])

  useEffect(->
    if viewNode?.get('treeQuery')? and not separateTreeQuery
      viewNode.unset('treeQuery')
    undefined
  , [separateTreeQuery])

  <>
    { showDefaultQueries(queryType, setFieldsValue) }
    <Form.Item
      name='queryType'
      label="Query language"
    >
      <Radio.Group
        onChange={(e) ->
          setQueryType(e.target.value)
          setFieldsValue({query: ''})
        }
      >
        { queryLanguages.map((lang) -> <Radio.Button key={lang} value={lang}>{ lang }</Radio.Button>) }
      </Radio.Group>
    </Form.Item>
    <Row gutter={32}>
      <Col flex={1}>
        <Form.Item
          name='query'
          required
          extra={extra}
          label={if separateTreeQuery then 'Graph query' else undefined}
          data-testid="create-view-graphquery"
        >
          <QueryEditor mode={queryType} />
        </Form.Item>
      </Col>
      {
        if separateTreeQuery
          <Col flex={1}>
            <Form.Item
              name='treeQuery'
              label='Tree query'
              data-testid="create-view-treequery"
            >
              <QueryEditor mode={queryType} />
            </Form.Item>
          </Col>
      }
    </Row>
    <Form.Item
      name='isPublic'
      valuePropName="checked"
      data-testid="create-view-is-public-query"
    >
      <Checkbox>Show view if project is public?</Checkbox>
    </Form.Item>
    <Checkbox
      checked={separateTreeQuery}
      data-testid="create-view-separate-tree-query"
      onChange={(e) -> setSeparateTreeQuery(e.target.checked)}
    >Separate query for the treeview?</Checkbox>
  </>

Graph.validateQuery = (fields) ->
  validateQueryBuilder = (q) ->
    await new Weaver.QueryBuilder(q)
      .build()
      .limit(0)
      .find()

  validateSparqlQuery = (q) ->
    bindings = await new Weaver.Sparql(q)
      .limit(0)
      .find()

    if not bindings.node
      throw new Error("No ?node binding found. Spreadsheet queries are required to select a single binding, which should be named ?node.")
    if _.keys(bindings).length > 1
      notification.warning({
        message: "Multiple bindings found."
        description: "The query you entered selects more than one binding. This will not cause errors, but additional bindings on top of the ?node binding will not be collected."
        duration: 5
      })

  queryValidatorMap = {
    'QueryBuilder': validateQueryBuilder
    'Sparql': validateSparqlQuery
  }

  await queryValidatorMap[fields.queryType](fields.query)
  await queryValidatorMap[fields.queryType](fields.treeQuery) if viewNode?.get('treeQuery')?

export default Graph
